<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							New Enrollment
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="studentCode" class="col-form-label">Student Code <span class="text-danger">*</span></label>
									<div class="input-group">
										<input type="text" v-model="enrollmentRequest.student_code" @blur="validationRule()" class="form-control" id="studentCode" readonly>
										<div class="input-group-append">
											<button type="button" class="btn btn-outline-secondary" @click="generateStudentCode()">
												<i class="fas fa-sync-alt"></i>
											</button>
										</div>
									</div>
									<small class="text-danger">{{validationData.student_code}}</small>
								</div>
								<div class="col-md-6">
									<label for="studentName" class="col-form-label">Student Name <span class="text-danger">*</span></label>
									<input type="text" v-model="enrollmentRequest.student_name" @blur="validationRule()" class="form-control" id="studentName">
									<small class="text-danger">{{validationData.student_name}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="phone" class="col-form-label">Phone <span class="text-danger">*</span></label>
									<input type="text" v-model="enrollmentRequest.phone" @blur="validationRule()" class="form-control" id="phone">
									<small class="text-danger">{{validationData.phone}}</small>
								</div>
								<div class="col-md-6">
									<label for="dateOfBirth" class="col-form-label">Date of Birth <span class="text-danger">*</span></label>
									<input type="date" v-model="enrollmentRequest.dob" @blur="validationRule()" class="form-control" id="dateOfBirth">
									<small class="text-danger">{{validationData.dob}}</small>
								</div>
								<!-- <div class="col-md-6">
									<label for="age" class="col-form-label">Age <span class="text-danger">*</span></label>
									<input type="number" v-model="enrollmentRequest.age" @blur="validationRule()" class="form-control" id="age">
									<small class="text-danger">{{validationData.age}}</small>
								</div> -->
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="gender" class="col-form-label">Gender <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.gender" @blur="validationRule()" class="form-control" id="gender">
										<option value="">Select Gender</option>
										<option value="male">Male</option>
										<option value="female">Female</option>
									</select>
									<small class="text-danger">{{validationData.gender}}</small>
								</div>
								<div class="col-md-6">
									<label for="address" class="col-form-label">Address <span class="text-danger">*</span></label>
									<input type="text" v-model="enrollmentRequest.address" @blur="validationRule()" class="form-control" id="address">
									<small class="text-danger">{{validationData.address}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="email" class="col-form-label">Email <span class="text-danger">*</span></label>
									<input type="text" v-model="enrollmentRequest.email" @blur="validationRule()" class="form-control" id="email">
									<small class="text-danger">{{validationData.email}}</small>
								</div>
								<div class="col-md-6">
									<label for="enrollmentDate" class="col-form-label">Enrollment Date <span class="text-danger">*</span></label>
									<input type="date" v-model="enrollmentRequest.enrollment_date" @blur="validationRule()" class="form-control" id="enrollmentDate">
									<small class="text-danger">{{validationData.enrollment_date}}</small>
								</div>
							</div>
							
							<div class="form-group row">
								<div class="col-md-6">
									<label for="parentName" class="col-form-label">Parent Name </label>
									<input type="text" v-model="enrollmentRequest.parent_name" @blur="validationRule()" class="form-control" id="parentName">
									<small class="text-danger">{{validationData.parent_name}}</small>
								</div>
								<div class="col-md-6">
									<label for="parentPhone" class="col-form-label">Parent Phone </label>
									<input type="text" v-model="enrollmentRequest.parent_phone" @blur="validationRule()" class="form-control" id="parentPhone">
									<small class="text-danger">{{validationData.parent_phone}}</small>
								</div>
							</div>
							<!-- <div class="form-group row">
								<div class="col-md-6">
									<label for="dateOfBirth" class="col-form-label">Date of Birth </label>
									<input type="date" v-model="enrollmentRequest.dob" @blur="validationRule()" class="form-control" id="dateOfBirth">
									<small class="text-danger">{{validationData.dob}}</small>
								</div>
							</div> -->
							<div class="form-group row">
								<div class="col-md-6">
									<label for="batchCode" class="col-form-label">Batch Code <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.batch_id" @blur="validationRule()" class="form-control" id="batchCode" @change="getFeeCode()">
										<option value="">Select Batch Code</option>
										<option v-for="batch in batchCodeList" :key="batch.id" :value="batch.id">{{ batch.code1}}{{ batch.code2 }}{{ batch.code3 }}</option>
									</select>
									<small class="text-danger">{{validationData.batch_id}}</small>
								</div>
								<div class="col-md-6">
									<label for="feeCode" class="col-form-label">Fee Code <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.fee_id" @blur="validationRule()" class="form-control" id="feeCode" @change="getTerm()">
										<option value="">Select Fee Code</option>
										<option v-for="fee in feeCodeList" :key="fee.id" :value="fee.id">{{ fee.code }}</option>
									</select>
									<small class="text-danger">{{validationData.fee_id}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="paymentTerm" class="col-form-label">Payment Term <span class="text-danger">*</span></label>
									<select v-model="enrollmentRequest.payment_terms_id" @blur="validationRule()" class="form-control" id="paymentTerm">
										<option value="">Select Payment Term</option>
										<option v-for="term in termList" :key="term.id" :value="term.id">{{ term.name }} - {{ term.payment_type.name }}</option>
									</select>
									<small class="text-danger">{{validationData.payment_terms_id}}</small>
								</div>
								<div class="col-md-6">
									<label for="discount" class="col-form-label">Discount </label>
									<select v-model="enrollmentRequest.discount" @blur="validationRule()" @change="calculateDiscount()" class="form-control" id="discount">
										<option value="">Select Discount</option>
										<option v-for="discount in discountList" :key="discount.id" :value="discount.id">{{ discount.name }}</option>
									</select>
									<small class="text-danger">{{validationData.discount}}</small>
								</div>
							</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="parentName" class="col-form-label">Total Fees <span class="text-danger">*</span></label>
									<input type="text" v-model="enrollmentRequest.total_fees" @blur="validationRule()" class="form-control" id="parentName">
									<small class="text-danger">{{validationData.total_fees}}</small>
								</div>
								<div class="col-md-6">
									<label for="discountAmount" class="col-form-label">Discount Amount</label>
									<input type="text" v-model="enrollmentRequest.discount_amount" readonly class="form-control" id="discountAmount">
									<small class="text-danger">{{validationData.discount_amount}}</small>
								</div>
							</div>

							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'enrollmentCreate',
		metaInfo: {
            title: "Enrollment Create",
            titleTemplate: "%s ← MIC",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				message: "",
				batchCodeList: [],
				discountList: [],
				feeCodeList: [],
				termList: [],
				originalFeeAmount: 0,
				enrollmentRequest: {
					student_code: "",
					student_name: "",
					phone: "",
					age: "",
					gender: "",
					dob: "",
					address: "",
					parent_name: "",
					parent_phone: "",
					enrollment_date: "",
					email: "",
					discount: "",
					batch_id: "",
					fee_id: "",
					payment_terms_id: "",
					total_fees: "",
					discount_amount: 0,
				},
				validationData: {
					student_code: "",
					student_name: "",
					phone: "",
					dob: "",
					gender: "",
					address: "",
					enrollment_date: "",
					email: "",
					batch_id: "",
					fee_id: "",
					payment_terms_id: "",
					total_fees: "",
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				enrollmentStoreAction: 'enrollmentStoreAction',
				getBatchCodeAction: 'getBatchCodeAction',
				getDiscountAction: 'getDiscountAction',
				getFeeCodeAction: 'getFeeCodeAction',
				getTermAction: 'getTermAction',
			}),
			async getDiscount(){
				await this.getDiscountAction().then(res => {
					this.discountList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getBatchCode(){
				await this.getBatchCodeAction().then(res => {
					this.batchCodeList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getFeeCode(){
				// Reset fee selection when batch changes
				this.enrollmentRequest.fee_id = "";
				this.enrollmentRequest.total_fees = "";
				this.enrollmentRequest.discount_amount = 0;
				this.feeCodeList = [];
				this.termList = [];

				let option = {
					batch_id: this.enrollmentRequest.batch_id
				}
				await this.getFeeCodeAction(option).then(res => {
					this.feeCodeList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getTerm(){
				// Reset payment term when fee changes
				this.enrollmentRequest.payment_terms_id = "";
				
				// Get the selected fee amount and recalculate discount
				this.getFeeAmount();
				
				let option = {
					fee_id: this.enrollmentRequest.fee_id
				}
				await this.getTermAction(option).then(res => {
					this.termList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			getFeeAmount(){
				if(this.enrollmentRequest.fee_id && this.feeCodeList.length > 0) {
					const selectedFee = this.feeCodeList.find(fee => fee.id == this.enrollmentRequest.fee_id);
					if(selectedFee) {
						// Set the original fee amount
						const feeAmount = selectedFee.amount || selectedFee.fee_amount || 0;
						this.enrollmentRequest.total_fees = feeAmount;
						this.originalFeeAmount = feeAmount;
						
						// Recalculate discount if discount is already selected
						this.calculateDiscount();
					}
				} else {
					// No fee selected, reset amounts
					this.enrollmentRequest.total_fees = "";
					this.enrollmentRequest.discount_amount = 0;
				}
			},
			calculateDiscount(){
				const originalAmount = this.originalFeeAmount;
				console.log(this.enrollmentRequest.discount)
				if(this.enrollmentRequest.discount && this.discountList.length > 0 && this.enrollmentRequest.discount != "") {
					const selectedDiscount = this.discountList.find(discount => discount.id == this.enrollmentRequest.discount);
					if(selectedDiscount) {
						let discountAmount = 0;
						
						if(selectedDiscount.discount_type === 'percentage') {
							// Calculate percentage discount
							discountAmount = (originalAmount * selectedDiscount.discount_value) / 100;
						} else if(selectedDiscount.discount_type === 'fixed') {
							// Calculate fixed discount
							discountAmount = selectedDiscount.discount_value;
						}
						
						// Ensure discount doesn't exceed original amount
						if(discountAmount > originalAmount) {
							discountAmount = originalAmount;
						}
						
						this.enrollmentRequest.discount_amount = discountAmount;
						this.enrollmentRequest.total_fees = originalAmount - discountAmount;
					}
				} else {
					console.log("No discount selected")
					console.log(originalAmount)
					// No discount selected, reset to original amount
					this.enrollmentRequest.discount_amount = 0;
					this.enrollmentRequest.total_fees = this.originalFeeAmount;
				}
			},
			generateStudentCode() {
				// Generate 6-character student code with letters and numbers
				const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
				let result = '';
				for (let i = 0; i < 6; i++) {
					result += characters.charAt(Math.floor(Math.random() * characters.length));
				}
				this.enrollmentRequest.student_code = result;
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('student_code', this.enrollmentRequest.student_code);
				formData.append('student_name', this.enrollmentRequest.student_name);
				formData.append('phone', this.enrollmentRequest.phone);
				formData.append('age', this.enrollmentRequest.age);
				formData.append('gender', this.enrollmentRequest.gender);
				formData.append('dob', this.enrollmentRequest.dob);
				formData.append('address', this.enrollmentRequest.address);
				formData.append('email', this.enrollmentRequest.email);
				formData.append('parent_name', this.enrollmentRequest.parent_name);
				formData.append('parent_phone', this.enrollmentRequest.parent_phone);
				formData.append('enrollment_date', this.enrollmentRequest.enrollment_date);
				formData.append('discount_id', this.enrollmentRequest.discount);
				formData.append('batch_id', this.enrollmentRequest.batch_id);
				formData.append('fee_id', this.enrollmentRequest.fee_id);
				formData.append('payment_terms_id', this.enrollmentRequest.payment_terms_id);
				formData.append('total_fees', this.enrollmentRequest.total_fees);
				formData.append('discount_amount', this.enrollmentRequest.discount_amount);

				await this.enrollmentStoreAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: '/enrollment-list', 
					query: {
						page: 1, 
						per_page: 10,
						sort_direction: 'desc', 
						sort_by: 'created_at',
						search_batch: '',
						search_fee: '',
						search_student: '',
						status: '',
						date_from: '',
						date_to: ''
					}
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.enrollmentRequest.student_code == "") {
					this.validationData.student_code = "The student code field is required."
					isValidation.push(true)
				} else {
					this.validationData.student_code = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.student_name == "") {
					this.validationData.student_name = "The student name field is required."
					isValidation.push(true)
				} else {
					this.validationData.student_name = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.phone == "") {
					this.validationData.phone = "The phone field is required."
					isValidation.push(true)
				} else {
					this.validationData.phone = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.dob == "") {
					this.validationData.dob = "The date of birth field is required."
					isValidation.push(true)
				} else {
					this.validationData.dob = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.gender == "") {
					this.validationData.gender = "The gender field is required."
					isValidation.push(true)
				} else {
					this.validationData.gender = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.address == "") {
					this.validationData.address = "The address field is required."
					isValidation.push(true)
				} else {
					this.validationData.address = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.email == "") {
					this.validationData.email = "The email field is required."
					isValidation.push(true)
				} else {
					this.validationData.email = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.enrollment_date == "") {
					this.validationData.enrollment_date = "The enrollment date field is required."
					isValidation.push(true)
				} else {
					this.validationData.enrollment_date = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.batch_id == "") {
					this.validationData.batch_id = "The batch code field is required."
					isValidation.push(true)
				} else {
					this.validationData.batch_id = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.fee_id == "") {
					this.validationData.fee_id = "The fee code field is required."
					isValidation.push(true)
				} else {
					this.validationData.fee_id = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.payment_terms_id == "") {
					this.validationData.payment_terms_id = "The payment term field is required."
					isValidation.push(true)
				} else {
					this.validationData.payment_terms_id = ""
					isValidation.push(false)
				}
				if (this.enrollmentRequest.total_fees == "") {
					this.validationData.total_fees = "The total fees field is required."
					isValidation.push(true)
				} else {
					this.validationData.total_fees = ""
					isValidation.push(false)
				}
				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
			// Auto-generate student code on load
			this.generateStudentCode()
			await this.getBatchCode()
			await this.getDiscount()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>